/* SWR configuration + axios fetcher
 *
 * Centralises the cache-keyed remote reads (dashboard, products, cart)
 * so navigating back to the same page is instant — SWR serves stale
 * data while it revalidates in the background.
 *
 * Used opt-in: components import { useSWR } from 'swr' directly and pass
 * a key + the fetcher exported here. The SWRConfig wrapper in App.js
 * provides default options (revalidate on focus, dedupe in 10s window).
 */
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export async function swrFetcher(path) {
  // Support both absolute paths and full URLs.
  const url = path.startsWith('http') ? path : `${API_URL}${path}`;
  const res = await axios.get(url, { withCredentials: true });
  return res.data;
}

export const swrDefaults = {
  fetcher: swrFetcher,
  // Don't pound the API every focus — most data is fine for a few seconds.
  dedupingInterval: 10_000,
  // Revalidate on focus is great for dashboards (operator switches tabs
  // and gets fresh data instantly) but disabled for public quote pages
  // via per-call options.
  revalidateOnFocus: true,
  revalidateOnReconnect: true,
  // Avoid hammering the API on flaky networks.
  errorRetryCount: 2,
};
